import { useQuery } from "@tanstack/react-query";
import { getUser } from "../apiUser";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";


export const UserProfileBox = ({ userId }) => {
    const { school } = useParams();
    const auth = useSelector(state => state.auth);

    const { data: userInfo } = useQuery({
        queryKey: ['user/info', userId],
        queryFn: getUser,
        refetchOnMount: 'always',
    });

    return (
        <div className="profile_box">
            <div className="profile_image">
                <Link to={`/${school}/user/${userId}/badge`}>
                    <img className="icon image" src={userInfo?.data?.image || `${process.env.PUBLIC_URL}/static/images/user/basic_badge.png`} alt="사용자 프로필 이미지" />
                </Link>
                {auth.id === userInfo?.data?.id &&
                    <Link to={`/${school}/user/modify`} className="btn btn_modify _xsm modal_open" ><img src={`${process.env.PUBLIC_URL}/static/images/user/setup_icon.png`} alt="변경" /></Link>
                }
            </div>
            <div className="profile">
                <p className="user_id">{userInfo?.data?.name}</p>
                <p className="school">{userInfo?.data?.school?.name}</p>
                <p className="number">{userInfo?.data?.grade}학년 {userInfo?.data?.schoolClass}반 {userInfo?.data?.studentNum}번</p>
            </div>
        </div>
    )
};